



















import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { JinroPlayStatus } from "@/services/jinro-play-status";
@Component({
  components: {}
})
export default class ShowPlayStatus extends Vue {
  @Prop() readonly currentStatus!: string;
  @Prop() readonly dayN!: number;
  isAnimated = true;
  isRounded = true;
  type = "is-dark";

  get activeStep(): number | null {
    if (this.currentStatus === JinroPlayStatus.Day) {
      return 0;
    } else if (
      this.currentStatus === JinroPlayStatus.Vote ||
      this.currentStatus === JinroPlayStatus.ExtraVote ||
      this.currentStatus === JinroPlayStatus.Execution
    ) {
      return 1;
    } else if (this.currentStatus === JinroPlayStatus.Night) {
      return 2;
    }
    return 0;
  }

  get labelForVoteOrExecution(): string {
    if (this.currentStatus === JinroPlayStatus.Execution) {
      return "処刑";
    }
    if (this.currentStatus === JinroPlayStatus.ExtraVote) {
      return "決選投票";
    }

    return "投票";
  }

  get iconForVoteOrExecution(): string {
    if (this.currentStatus === JinroPlayStatus.Execution) {
      return "fas fa-skull-crossbones";
    }
    return "fas fa-vote-yea";
  }

  get showSteps(): boolean {
    if (
      this.currentStatus === JinroPlayStatus.Day ||
      this.currentStatus === JinroPlayStatus.Vote ||
      this.currentStatus === JinroPlayStatus.ExtraVote ||
      this.currentStatus === JinroPlayStatus.Execution ||
      this.currentStatus === JinroPlayStatus.Night
    ) {
      return true;
    } else {
      return false;
    }
  }
}
